import { useEffect, useState } from 'react';
import { Typography } from '../typography';
import { Button } from '../button';
import { ModalBase, ModalWrapper, ModalFooterButtons } from './ModalComponents';
import { useDeleteManageSalesMutation } from '../../hooks';
import { enqueueSnackbar } from '../snackbar';
import { MESSAGES } from '../../const';
import { i18n } from '../../i18n';

interface ManageSalesDeleteModalType {
  data: {
    id: string;
    number: string;
  }[];
  submitClick: () => void;
  open: () => void;
}

export const managesalesDeleteModal: ManageSalesDeleteModalType = {
  data: [],
  submitClick: () => null,
  open: () => null,
};

export const ManageSalesDeleteModal = () => {
  const { mutate } = useDeleteManageSalesMutation();
  const [open, setOpen] = useState(false);

  useEffect(() => {
    managesalesDeleteModal.open = () => {
      setOpen(true);
    };
  }, []);

  const handleOnClose = () => {
    managesalesDeleteModal.data = [];
    setOpen(!open);
  };

  const handleSubmitClick = async () => {
    mutate(
      managesalesDeleteModal.data.map((item) => ({
        id: item.id,
      })),
      {
        onSuccess: () => {
          setOpen(false);
          managesalesDeleteModal.submitClick();
        },
        onError: () => {
          enqueueSnackbar(MESSAGES.MANAGE_SALES.ERROR.NOT_DELETED, 'error');
        },
      },
    );
  };

  return (
    <ModalBase id={'managesales-delete-modal'} open={open} onClose={handleOnClose}>
      <ModalWrapper>
        <Typography variant={'textL'} weight={'bold'}>
          {i18n.t('dropdown.stopSelling')}
        </Typography>
        {managesalesDeleteModal.data.map((item, i) => (
          <Typography key={i} variant={'textM'}>
            {item.number}
          </Typography>
        ))}
        <ModalFooterButtons>
          <Button size={'medium'} data-color={'white'} onClick={handleOnClose}>
            {i18n.t('button.cancel')}
          </Button>
          <Button size={'medium'} data-color={'primary'} onClick={handleSubmitClick}>
            {i18n.t('button.submit')}
          </Button>
        </ModalFooterButtons>
      </ModalWrapper>
    </ModalBase>
  );
};
